import React, { useEffect } from "react";
import { motion, useInView, useAnimation } from "framer-motion";

// New / updated components
import Hero from "../components/Hero";
import AchivementArea from "../components/AchivementArea"; // standardised stats
import WhyChooseUs from "../components/WhyChooseUs"; // polished mission/vision/values
import FeatureArea from "../components/FeatureArea"; // polished “Why Choose Sagama”
import Announcement from "../components/Announcement";
import Offer from "../components/Offers";
import Properties from "../components/Properties";
import Plot from "../components/Plot";
import CtaArea from "../components/CtaArea";
import Estates from "../components/Estates";
import TeamArea from "../components/TeamArea";
import TestimonialArea from "../components/TestimonialArea";
import BlogArea from "../components/BlogArea";
import EstateShowcase from "../components/EstateShowcase";

// ---- Fade-up wrapper using framer-motion (no extra dependencies) ----
const FadeUpSection = ({ children }) => {
  const controls = useAnimation();
  const ref = React.useRef(null);
  const inView = useInView(ref, { once: true, margin: "-50px" });

  useEffect(() => {
    if (inView) controls.start("visible");
  }, [controls, inView]);

  return (
    <motion.div
      ref={ref}
      animate={controls}
      initial="hidden"
      variants={{
        visible: { opacity: 1, y: 0 },
        hidden: { opacity: 0, y: 30 },
      }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

const Home = () => {
  return (
    <div>
      <Hero />

      <FadeUpSection>
        <AchivementArea />
      </FadeUpSection>

     
      <FadeUpSection>
        <EstateShowcase />
      </FadeUpSection>

      <FadeUpSection>
        <WhyChooseUs />
      </FadeUpSection>

      <FadeUpSection>
        <FeatureArea />
      </FadeUpSection>

      <FadeUpSection>
        <Announcement />
      </FadeUpSection>

      <FadeUpSection>
        <Offer />
      </FadeUpSection>

      <FadeUpSection>
        <Properties />
      </FadeUpSection>

      <FadeUpSection>
        <Plot />
      </FadeUpSection>

      <FadeUpSection>
        <CtaArea />
      </FadeUpSection>

      <FadeUpSection>
        <Estates />
      </FadeUpSection>

      {/* <FadeUpSection>
        <FeaturedLayouts />
       </FadeUpSection> */}

      <FadeUpSection>
        <TeamArea />
      </FadeUpSection>

      <FadeUpSection>
        <TestimonialArea />
      </FadeUpSection>
      <FadeUpSection>
        <BlogArea />
      </FadeUpSection>
    </div>
  );
};

export default Home;
